import React, { useState, useEffect } from "react";

import Table from "./Table";
import pages from "../../../../constants/pages";
import { useAxios, useComponent } from "../../../../hooks";
import { PageHeader, Loader } from "../../../../components";

export default function ReverseMappingHistory() {
  const axios = useAxios();
  const { loader } = useComponent();

  const [processes, setProcesses] = useState([]);
  const [rows, setRows] = useState(0);
  const [processActivity, setProcessActivity] = useState({
    cancel: "",
    regenerateFile: "",
  });

  useEffect(() => {
    loader.start();

    axios({
      url: "/processes?skip=0&limit=21&api=reverse_rc",
    }).then((response) => {
      if (response.status) {
        setProcesses(response.data.paginatedResults);
        setRows(response.data.totalCount[0]?.count);
        loader.apiComplete();
      }
    });
  }, [axios, loader, processActivity.cancel, processActivity.regenerateFile]);

  return (
    <Loader>
      <PageHeader
        pageName="Bulk Reverse RC List"
        addIcon={[
          "Create Bulk Reverse RC ",
          pages.reverseMappingCreate.route,
          true,
        ]}
      />

      <Table
        processes={processes}
        setProcesses={setProcesses}
        setProcessActivity={setProcessActivity}
        rows={rows}
        setRows={setRows}
      />
    </Loader>
  );
}
